export const announcements = [
  {
    id: 'ann-1',
    text: '🎉 新會員首單享9折優惠！立即註冊領取專屬優惠券',
    link: '/register',
    type: 'promotion'
  },
  {
    id: 'ann-2',
    text: '⚡ UID自動儲值全新上線！原神、崩鐵、絕區零即時到賬',
    link: '/uid',
    type: 'feature'
  },
  {
    id: 'ann-3',
    text: '🔥 本月特價活動：精選遊戲最低8折起，數量有限搶購中',
    link: '/special',
    type: 'sale'
  },
  {
    id: 'ann-4',
    text: '📢 系統維護通知：每日凌晨2:00-3:00進行系統維護，請避開此時段下單',
    link: '/notice',
    type: 'notice'
  },
  {
    id: 'ann-5',
    text: '💎 VIP會員專享：累計消費滿5000元升級VIP，享終身85折優惠',
    link: '/vip',
    type: 'vip'
  },
  {
    id: 'ann-6',
    text: '🎮 新遊戲上架：三角洲行動、明日方舟終末地等熱門遊戲已開放儲值',
    link: '/new',
    type: 'new'
  }
];